import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import CastingCommon    from '@utils/casting-common';
// -------------------------------------------------------

const Tooltip = ({children}) => children || null;
const OverlayTrigger = ({children}) => children || null;

class MainAction extends React.Component {
  updateStatus(update) {
    let detail = this.props.detail;
    
    Utils.request.bind(this)('/api/project/influencer/status_update', { project_id: detail.project_id, insta_user_id: detail.insta_user_id, update: update },
      function(res){
        this.props.base.event.updateData('workflow', res.body.workflow);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  actionEvent() {
    let mode = this.props.mode;
    let detail = this.props.detail;
    
    if( mode == 'client_check'  ) this.props.base.event.showClientCheckModal.bind(this)([detail.insta_user_id]);
    if( mode == 'assign_action' ) this.props.base.event.showAssignModal.bind(this)(detail.project_id, [detail.insta_user_id]);
    if( mode == 'draft_action'  ) this.props.base.event.showDraftModal.bind(this)([detail.insta_user_id]);
  }
  // -------------------------------------------------------
  
  cancelEvent() {
    let mode = this.props.mode;
    
    if( mode == 'client_check'  ) this.updateStatus.bind(this)({ column: 'is_client_check', value: 0 });
    if( mode == 'assign_action' ) this.updateStatus.bind(this)({ column: 'is_assign', value: 0 });
    if( mode == 'draft_action'  ) this.updateStatus.bind(this)({ column: 'is_draft', value: 0 });
  }
  // -------------------------------------------------------
  
  getErrorMsg() {
    let mode = this.props.mode;
    let status = this.props.detail.workflow_status;
    if( status == undefined ) status = {};
    
    if( mode == 'client_check' ){
      if( status.is_client_check_complete == 1 ) return 'クライアント確認済みです';
      return 'ワークフローを「クライアント確認」に設定してください';
    }
    if( mode == 'assign_action' ){
      if( status.is_entry == 1 ) return 'エントリー済みです';
      return 'ワークフローを「アサインアクション」に設定してください';
    }
    if( mode == 'draft_action' ){
      if( status.is_entry == 0 ) return '未エントリーのインフルエンサーです';
      if( status.is_draft_complete == 1 ) return '下書き確認済みです';
      return 'ワークフローを「下書き」に設定してください';
    }
    
    return '現在使用できません';
  }
  // -------------------------------------------------------
  
  render() {
    let mode = this.props.mode;
    let request_action = CastingCommon.getRequestAction(this.props.base, this.props.detail.insta_user_id, 'full_task');
    
    // アクション
    if( mode == request_action ){
      return (
        <li className="on" onClick={this.actionEvent.bind(this)}>
          {this.props.button}
        </li>
      );
    }
    
    // キャンセル
    if( mode +'_cancel' == request_action ){
      return (
        <li className="on" onClick={this.cancelEvent.bind(this)}>
          {this.props.button}
          <p className="cancel">キャンセル</p>
        </li>
      );
    }
    
    // 使用できない
    return (
      <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>{this.getErrorMsg.bind(this)()}</Tooltip>}>
        <li className="off">
          {this.props.button}
        </li>
      </OverlayTrigger>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default MainAction;